import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { decorators, Paginator } from "@orange-marmalade/paginate-this";
import { DataTable, IconReceived, PartNumber } from "MODULES/shared/components";
import { isEmpty } from "lodash";

const paginatorList = "shipments/lineItems";

const ReceivedIcon = ({ quantity_received: quantityReceived, quantity }) => {
  if (quantityReceived === quantity) {
    return <IconReceived />;
  }
  return null;
};

ReceivedIcon.propTypes = {
  quantity_received: PropTypes.number,
  quantity: PropTypes.number
};

class LineItemsTable extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
    isLoading: PropTypes.bool.isRequired
  };

  renderRow = (r, idx) => (
    <tr
      key={r.id}
      className={classNames("clickable", { "text-muted": r.cancelled })}
    >
      <td>
        <div style={{ whiteSpace: "nowrap" }}>
          <div style={{ textAlign: "right" }}>{idx + 1}</div>
        </div>
      </td>
      <td>
        <PartNumber part={r.part} />
      </td>
      <td>
        {isEmpty(r.inventory_link_id) ? (
          r.serial_number
        ) : (
          <Link to={`/inventories/${r.inventory_link_id}`}>
            {r.serial_number}
          </Link>
        )}
      </td>
    </tr>
  );

  render() {
    const { results, isLoading } = this.props;

    return (
      <div>
        <DataTable.Mini loading={isLoading} numbered noMargin>
          <DataTable.Head>
            <th />
            <th>Part #</th>
            <th>Serial #</th>
          </DataTable.Head>
          <DataTable.Body>{results.map(this.renderRow)}</DataTable.Body>
        </DataTable.Mini>
        <nav
          className="text-center margin-top-none"
          aria-label="Search results pages"
        >
          <Paginator listId={paginatorList} />
        </nav>
      </div>
    );
  }
}

const ConnectedTable = decorators.tabulate(LineItemsTable);

export default props => <ConnectedTable listId={paginatorList} {...props} />;



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Body/LineItemsTable/LineItemsTable.jsx